export const root = '/';
export const search = '/search';
export const searchResult = '/search/result';
export const signInPhoneNumber = '/sign-in/phone-number';
export const signInPhoneNumberConfirm = '/sign-in/phone-number/confirm';
export const signUp = '/sign-up';
export const signUpConfirm = '/sign-up/confirm';
export const restaurants = '/restaurants';
export const reservationConfirm = '/reservation/confirm';
export const reservations = '/reservations';
export const finished = 'finished';
export const canceled = 'canceled';
export const profileCreate = '/profile/create';
export const accountEdit = '/account/edit';
export const createEmail = '/account/create/email';
export const editPhoneNumber = '/account/edit/phone-number';
export const editEmail = '/account/edit/email';
export const updateEmail = '/account/update/email';
export const updatePassword = '/account/update/password';
export const notFound = '/not-found';
